import { useContext } from 'react';
import { ContextGamesBase } from 'src/contexts';

// ========================================================================== //
// ================================= LOGIC ================================== //
// ========================================================================== //

/**
 * @description - The hook for the game component. This is containing all
 * necessary lifecycle methods and variables.
 */
const useGame = () => {
  const context = useContext(ContextGamesBase);

  if (!context) throw new Error(
    'Game context must be use inside GameBaseProvider'
  );

  return context;
};

export default useGame;
